import { render, staticRenderFns } from "./SelectDepartment.vue?vue&type=template&id=83b3d3a6&scoped=true&"
import script from "./SelectDepartment.vue?vue&type=script&lang=js&"
export * from "./SelectDepartment.vue?vue&type=script&lang=js&"
import style0 from "./SelectDepartment.vue?vue&type=style&index=0&id=83b3d3a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b3d3a6",
  null
  
)

export default component.exports